var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 50,
    viewBox: "0 0 73 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69978 35.7143C9.19286 35.7143 9.59263 35.3145 9.59263 34.8214V5.35714C9.59263 3.38504 11.192 1.78571 13.1641 1.78571H59.5926C61.5647 1.78571 63.1641 3.38504 63.1641 5.35714V34.8214C63.1641 35.3145 63.5638 35.7143 64.0569 35.7143C64.55 35.7143 64.9498 35.3145 64.9498 34.8214V5.35714C64.9498 2.41071 62.5391 0 59.5926 0H13.1641C10.2176 0 7.80692 2.41071 7.80692 5.35714V34.721C7.80692 35.4129 8.20647 35.7143 8.69978 35.7143ZM70.3069 39.2857H2.44978C1.46629 39.2857 0.664062 40.0896 0.664062 41.0714V42.8571C0.664062 46.7857 3.87946 50 7.80692 50H64.9498C68.8772 50 72.0926 46.7857 72.0926 42.8571V41.0714C72.0926 40.1897 71.2891 39.2857 70.3069 39.2857ZM70.3069 42.8571C70.3069 45.8114 67.904 48.2143 64.9498 48.2143H7.80692C4.85268 48.2143 2.44978 45.8114 2.44978 42.8571V41.0714H70.3069V42.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.cf8e1406ec80569b50e26c797f20ebd3.svg";
export { ForwardRef as ReactComponent };